<template>
  <div>
    <!-- [ Modal form Add Task ] start -->
    <sweet-modal blocking :title="stateTask === 'edit' ? $t('modal_editBusinessUnitTask') : $t('modal_addNewBusinessUnitTask')" ref="addTask" class="modal" v-on:close="closeTaskModal">
        <el-form :model="formAddTask" status-icon :rules="rules" ref="formAddTask" class="demo-ruleForm" size="mini">
          <el-form-item prop="taskName">
              <el-input :label="$t('modal_taskName')" v-model="formAddTask.taskName"></el-input>
          </el-form-item>
          <el-row :gutter="20">
              <el-col :span="12">
                  <el-form-item v-if="stateTask === 'add' || stateTask === 'insert'" prop="typeTaskId">
                      <el-select no-data-text="no date" v-model="formAddTask.typeTaskId" :placeholder="$t('modal_taskType')">
                          <el-option
                                  v-for="item in formAddTask.typeTask"
                                  :key="item.id"
                                  :label="item.name"
                                  :value="item.id"
                                  @click.native="handleTaskFunctions('getTaskFunctionList', item.id)">
                          </el-option>
                      </el-select>
                  </el-form-item>
              </el-col>
              <el-col :span="12">
                  <el-form-item  v-if="stateTask === 'add' || stateTask === 'insert'" prop="functionTaskId">
                      <el-select no-data-text="no date" v-model="formAddTask.functionTaskId" :placeholder="$t('modal_taskFunction')">
                          <el-option
                                  v-for="item in formAddTask.functionTask"
                                  :key="item.id"
                                  :label="item.name"
                                  :value="item.id">
                          </el-option>
                      </el-select >
                  </el-form-item>
                  <el-form-item prop="taskPriorityId">
                      <el-select v-model="formAddTask.taskPriorityId" :placeholder="$t('modal_taskPriority')">
                          <el-option
                                  v-for="priority in formAddTask.taskPriority"
                                  :key="priority.id"
                                  :label="priority.name"
                                  :value="priority.id"></el-option>
                      </el-select>
                  </el-form-item>
              </el-col>
          </el-row>

          <!-- <el-form-item label-width="100px" size="medium">
              <div>
                  <el-button style="width: 100%;" class="btn-wrap" slot="button" v-on:click="$refs.nestedChild.open()" size="mini" type="primary" plain>{{$t('modal_aboutThisTask')}}</el-button>
              </div>
          </el-form-item> -->

          <div class="aboutButton">
            <el-button style="width: 100%;" class="btn-wrap" slot="button" v-on:click="$refs.nestedChild.open()" size="medium" type="primary" plain>{{$t('modal_aboutThisTask')}}</el-button>
          </div>

          <!-- :label="$t('modal_addProgressNote')" label-width="120px" -->
          <el-form-item>
              <el-switch active-color="#13ce66" v-model="formAddTask.progressNote" :disabled="addProgDisabled || editDisabled && taskStatus !== 1"></el-switch> {{$t('modal_addProgressNote')}}
          </el-form-item>

          <!-- :label="$t('modal_reoccuringTask')" label-width="120px" -->
          <el-form-item prop="reoccuringTask">
              <el-switch active-color="#13ce66" @change="changing" :disabled="isEditActivated && taskStatus !== 1 || (formAddTask.deadline && !formAddTask.reoccuringTask)" v-model="formAddTask.reoccuringTask"></el-switch> {{$t('modal_reoccuringTask')}}
          </el-form-item>

          <el-row :gutter="20" v-if="formAddTask.reoccuringTask">
              <el-col :span="12">
                  <el-form-item prop="daysCount" >
                      <el-input :label="$t('modal_repeatTask')" type="number" v-model="formAddTask.daysCount" ></el-input>
                  </el-form-item>
              </el-col>
              <el-col :span="12">
                  <el-form-item prop="startDay">
                      <el-date-picker
                              format="d MMM yy h:mm a"
                              v-model="formAddTask.startDay"
                              type="datetime"
                              :placeholder="$t('modal_startDay')"
                              value-format="timestamp">
                      </el-date-picker>
                  </el-form-item>
              </el-col>
          </el-row>
          <el-row v-if="formAddTask.reoccuringTask">
            <!-- :label="$t('modal_numberOfRepetitions')" label-width="150px" -->
              <el-form-item size="mini" prop="reocuringCounter">
                  <el-radio @change="cangedReocuringCount" v-model="formAddTask.reocuringCount" :label="false">{{$t('modal_numberOfRepetitions_infinitely')}}</el-radio>
                  <el-radio v-model="formAddTask.reocuringCount" :label="true">{{$t('modal_numberOfRepetitions_setNumber')}}</el-radio>
                  <el-input size="mini" v-if="formAddTask.reocuringCount" type="number" v-model="formAddTask.reocuringCounter" class="input-recuring-counter"></el-input>
              </el-form-item>
          </el-row>

          <!-- :label="$t('modal_setDeadline')" label-width="120px" -->
          <el-form-item>
              <el-switch active-color="#13ce66" :disabled="isEditActivated && taskStatus !== 1 || (!formAddTask.deadline && formAddTask.reoccuringTask)" v-model="formAddTask.deadline"></el-switch> {{$t('modal_setDeadline')}}
          </el-form-item>
          <el-row :gutter="20" v-if="formAddTask.deadline">
              <el-col :span="12">
                  <el-form-item>
                      <el-date-picker
                              v-model="formAddTask.endedDate"
                              type="datetime"
                              :placeholder="$t('modal_endedDate')"
                              format="d MMM yy h:mm a"
                              value-format="timestamp"
                      >
                      </el-date-picker>
                  </el-form-item>
              </el-col>
          </el-row>

          <el-row :gutter="20">
              <el-col :span="12">
                  <el-form-item>
                      <el-select no-data-text="no date" v-model="formAddTask.taskTeamId" multiple :placeholder="$t('modal_taskTeam')" @remove-tag="removeTag">
                          <el-option
                                  v-for="item in formAddTask.taskTeam"
                                  :key="item.id"
                                  :label="item.user.fullName"
                                  :value="item.id"
                                  :class="{ disabled: item.status != 1 }"
                                  @click.native="handleSelectTeam(item)">
                          </el-option>
                      </el-select>
                  </el-form-item>
              </el-col>
              <el-col :span="12">
                  <el-form-item v-if="formAddTask.reoccuringTask" prop="assignedToId">
                      <el-select v-model="formAddTask.assignedToId" :placeholder="$t('modal_assignedTo')">
                          <el-option
                                  v-for="assign in formAddTask.assignedTo"
                                  :key="assign.id"
                                  :label="assign.user.fullName"
                                  :value="assign.id"
                                  :class="{ disabled: assign.status != 1 }"></el-option>
                      </el-select>
                  </el-form-item>
                  <el-form-item v-else>
                      <el-select clearable v-model="formAddTask.assignedToId" :placeholder="$t('modal_assignedTo')">
                          <el-option
                                  v-for="assign in formAddTask.assignedTo"
                                  :key="assign.id"
                                  :label="assign.user.fullName"
                                  :value="assign.id"
                                  :class="{ disabled: assign.status != 1 }"></el-option>
                      </el-select>
                  </el-form-item>
              </el-col>
          </el-row>

          <el-row :gutter="20">
              <el-col :span="12">
                  <el-form-item prop="projectClientListId">
                      <el-select no-data-text="no date" v-model="formAddTask.clientsId" multiple placeholder="Client Contacts">
                          <el-option-group
                                  class="select-group"
                                  @click.native="ggg(group)"
                                  v-for="group in newClientList"
                                  :key="group.companyClientId"
                                  :label="group.companyClient.name">
                              <el-option
                                      v-for="item in group.people"
                                      :key="item.id"
                                      :label="item.fullName"
                                      :value="item.id">
                              </el-option>
                          </el-option-group>
                      </el-select>
                  </el-form-item>
                  <el-form-item prop="projectVendorListId">
                      <el-select v-model="formAddTask.vendorsId" placeholder="Vendor Contacts" multiple>
                          <el-option-group
                                  class="select-group"
                                  @click.native="ggg(group)"
                                  v-for="group in newVendorList"
                                  :key="group.companyVendorId"
                                  :label="group.companyVendor.name">
                              <el-option
                                      v-for="item in group.people"
                                      :key="item.id"
                                      :label="item.fullName"
                                      :value="item.id">
                              </el-option>
                          </el-option-group>
                      </el-select>
                  </el-form-item>
              </el-col>
              <el-col :span="12">
                  <el-form-item>
                      <el-switch active-color="#13ce66" v-model="formAddTask.allowExternalNotification"></el-switch> {{$t('modal_allowClientVendorNotifications')}}
                  </el-form-item>
                  <el-form-item>
                      <el-switch active-color="#13ce66" v-model="formAddTask.addTaskDocuments"></el-switch> {{$t('modal_addTaskDocuments')}}
                  </el-form-item>
              </el-col>
          </el-row>

          <!-- DM -->
          <el-row v-if="formAddTask.addTaskDocuments" :gutter="20">
              <el-col :span="12">
                  <el-form-item>
                      <el-select v-model="formAddTask.sopListId" :placeholder="$t('modal_sop')" clearable>
                          <el-option v-for="item in formAddTask.sopList"
                                      :key="item.id"
                                      :label="item.name"
                                      :value="item.id">
                          </el-option>
                      </el-select>
                  </el-form-item>
              </el-col>
              <el-col :span="12">
                  <el-form-item>
                      <el-select v-model="formAddTask.policyListId" :placeholder="$t('modal_policy')" clearable>
                          <el-option v-for="item in formAddTask.policyList"
                                      :key="item.id"
                                      :label="item.name"
                                      :value="item.id">
                          </el-option>
                      </el-select>
                  </el-form-item>
              </el-col>
          </el-row>
          <el-row v-if="formAddTask.addTaskDocuments" :gutter="20">
              <el-col :span="12">
                  <el-form-item>
                      <el-select v-model="formAddTask.healthSafetyListId" :placeholder="$t('modal_healthSafety')" clearable>
                          <el-option v-for="item in formAddTask.healthSafetyList"
                                      :key="item.id"
                                      :label="item.name"
                                      :value="item.id">
                          </el-option>
                      </el-select>
                  </el-form-item>
              </el-col>
              <el-col :span="12">
                  <el-form-item>
                      <el-select v-model="formAddTask.riskAssesmentListId" :placeholder="$t('modal_commercial')" clearable>
                          <el-option v-for="item in formAddTask.riskAssesmentList"
                                      :key="item.id"
                                      :label="item.name"
                                      :value="item.id">
                          </el-option>
                      </el-select>
                  </el-form-item>
              </el-col>
          </el-row>
          <el-row v-if="formAddTask.addTaskDocuments" :gutter="20">
              <el-col :span="12">
                  <el-form-item>
                      <el-select v-model="formAddTask.envirenmentalListId" :placeholder="$t('modal_general')" clearable>
                          <el-option v-for="item in formAddTask.envirenmentalList"
                                      :key="item.id"
                                      :label="item.name"
                                      :value="item.id">
                          </el-option>
                      </el-select>
                  </el-form-item>
              </el-col>
              <el-col :span="12"></el-col>
          </el-row>

          <div class="flex-end" v-if="stateTask === 'add'">
              <el-form-item>
                  <el-button size="medium" @click="modalCancel('addTask')">{{$t('general_cancel')}}</el-button>
                  <el-button size="medium" @click="addTaskSubmit('formAddTask')" class="modal__btn" type="primary">{{$t('general_submit')}}</el-button>
              </el-form-item>
          </div>
          <div class="flex-end" v-else-if="stateTask === 'edit'">
              <el-form-item>
                  <el-button size="medium" @click="modalCancel('addTask')">{{$t('general_cancel')}}</el-button>
                  <el-button size="medium" @click="editTaskSubmit('formAddTask')" class="modal__btn" type="primary">{{$t('general_submit')}}</el-button>
              </el-form-item>
          </div>
          <div class="flex-end" v-else-if="stateTask === 'insert'">
              <el-form-item>
                  <el-button size="medium" @click="modalCancel('addTask')">{{$t('general_cancel')}}</el-button>
                  <el-button size="medium" @click="addTaskInsert('formAddTask')" class="modal__btn" type="primary">{{$t('general_submit')}}</el-button>
              </el-form-item>
          </div>
      </el-form>
    </sweet-modal>
    <!-- [ Modal form Add Task ] end -->

    <sweet-modal blocking ref="nestedChild">
      <vue2-custom-editor
          ref="editor"
          v-model="formAddTask.aboutThisTask"
          style="margin-bottom: 20px;"
          :placeholder="$t('modal_aboutThisTask')">
      </vue2-custom-editor>
      <!-- <el-button slot="button" v-on:click="$refs.nestedChild.close()">{{$t('general_ok')}}</el-button> -->
      <div class="modal__btn">
        <el-button slot="button" v-on:click="$refs.nestedChild.close()" type="primary">{{$t('general_ok')}}</el-button>
      </div>
    </sweet-modal>
  </div>
</template>

<script>
  import { SweetModal } from '@totalflow4/tfsweet-modal-vue';
  import axios from 'axios';
  import moment from 'moment'
  import Vue2CustomEditor from "../vue-2-custom-editor";

  export default {
    name: "CreateBusinessUnitTask",
    props: {
      selectedRow: {
        type: Object,
        required: true
      },
    },
    computed: {
      reoccuringTask() {
        return this.formAddTask.reoccuringTask
      },
    },
    components:{
      Vue2CustomEditor,
      SweetModal
    },
    data() {
      var checkRepeatTask = (rule, value, callback) => {
        if (!value && this.addProgDisabled) {
          return callback(new Error('Please input the field'));
        }else if(value == 0 && this.addProgDisabled){
          return callback(new Error('Repeat task interval cant be 0'));
        }else callback();
      }
      var checkStartDay = (rule, value, callback) => {
        if (!value && this.addProgDisabled) {
          return callback(new Error('Please input the field'));
        }else callback();
      }
      var checkNumberOfRepetitions = (rule, value, callback) => {
        if (!value && this.formAddTask.reocuringCount) {
          return callback(new Error('Please input the field'));
        }else if(value == 0 && this.formAddTask.reocuringCount){
          return callback(new Error('Number of repetitions cant be 0'));
        }else callback();
      }
      return {
        editDisabled: false,
        isEditActivated:false,
        addProgDisabled: false,
        stateTask: '',
        newVendorList: [],
        newClientList: [],
        changeDayOrHourList: [{
          label: "Days",
          value: 1
        }],
        changeDayOrHour: 1,
        formAddTask: {
          deadline: false,
          endedDate: null,
          taskName: '',
          functionTaskId: '',
          functionTask: [],
          typeTask: '',
          typeTaskId: '',
          taskTeam: [],
          taskTeamId: [],
          reoccuringTask: false,
          aboutThisTask: '',
          daysCount: 1,
          taskPriorityId: '',
          taskPriority: [],
          assignedTo: [],
          assignedToId: null,
          progressNote: false,
          timeSheet: false,
          addTaskDocuments: false,
          allowExternalNotification: false,
          startDay: '',
          reocuringCount: false,
          reocuringCounter: 1,
          clients: '',
          clientsId:[],
          vendors: '',
          vendorsId:[],

          // DM
          sopList: [],
          sopListId: null,
          policyList: [],
          policyListId: null,
          healthSafetyList: [],
          healthSafetyListId: null,
          riskAssesmentList: [],
          riskAssesmentListId: null,
          envirenmentalList: [],
          envirenmentalListId: null,
        },
        rules: {
          taskName: [
            { required: true, message: 'Please input Task name', trigger: 'blur' }
          ],
          typeTaskId: [
            { required: true, message: 'Please select Task Type', trigger: 'change' }
          ],
          taskPriorityId:[
            { required: true, message: 'Please select Activity zone', trigger: 'change' }
          ],
          assignedToId: [
            { required: true, message: 'Please Assigned To', trigger: 'change' }
          ],
          functionTaskId:[
            { required: true, message: 'Please pick a Task Function', trigger: 'blur' }
          ],
          daysCount: [{ validator: checkRepeatTask, trigger: 'blur' }],
          startDay: [{ validator: checkStartDay, trigger: 'blur' }],
          reocuringCounter: [{ validator: checkNumberOfRepetitions, trigger: 'blur' }]
        },
        taskStatus: 1
      }
    },
    methods:{
      openModal(state) {
        let loader = this.$loading.show();
        this.stateTask = state
        let operation = ''
        if(state === 'add'){
          operation = 'create'
        }else if(state === 'edit'){
          operation = 'update'
        }else if (state === 'insert'){
          operation = 'create'
        }
        console.log('---', 'add');
        this.$refs.addTask.open();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.post(`/api/v1/businessUnitTasks/directories?companyId=${this.$route.query.companyId}&businessUnitId=${this.$route.query.businessUnitId}&operation=${operation}`)
          .then(response => {
            if (response.data.success){
              console.log("getBusinessUnitDir", response.data);
              this.formAddTask.taskPriority = response.data.priorityList
              this.formAddTask.typeTask = response.data.taskTypeList
              // this.formAddTask.assignedTo = response.data.companyUserList
              this.formAddTask.taskTeam = response.data.companyUserList

              // DM
              this.formAddTask.sopList = response.data.sopList
              this.formAddTask.policyList = response.data.policyList
              this.formAddTask.healthSafetyList = response.data.healthSafetyList
              this.formAddTask.riskAssesmentList = response.data.riskAssesmentList
              this.formAddTask.envirenmentalList = response.data.envirenmentalList

              this.newVendorList = this.createMyList(response.data.companyVendorList, response.data.companyVendorPersonList, 'vendors')
              this.newClientList = this.createMyList(response.data.companyClientList, response.data.companyClientPersonList, 'clients')

              this.$nextTick(() => {
                this.$refs.editor.setImagesState()
              })

              if(state === 'add' || state === 'insert') {
                loader.hide()
              }
            }
            if(state === "edit") {
              this.isEditActivated = true
              axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
              axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
              axios.post(`/api/v1/businessUnitTasks/item?companyId=${this.$route.query.companyId}&businessUnitId=${this.$route.query.businessUnitId}&businessUnitTaskId=${this.selectedRow.id}`)
                .then(response => {
                  if (response.data.success){
                    console.log("EDIT TASK", response.data);
                    if(response.data.item.isReoccurring === 1){
                      this.formAddTask.reoccuringTask = true
                    }else{
                      this.formAddTask.reoccuringTask = false
                    }
                    if(response.data.item.hasProgress === 1){
                      this.formAddTask.progressNote = true;
                      this.editDisabled = true
                    }else{
                      this.formAddTask.progressNote = false
                    }
                    this.formAddTask.taskName = response.data.item.name;
                    this.formAddTask.aboutThisTask = response.data.item.description;
                    this.formAddTask.taskPriorityId = response.data.item.priorityId;
                    if(response.data.item.repeatTaskInterval % 24 === 0){
                      this.formAddTask.daysCount = response.data.item.repeatTaskInterval / 24;
                      this.changeDayOrHour = 1
                    }else{
                      this.formAddTask.daysCount = response.data.item.repeatTaskInterval;
                      this.changeDayOrHour = 2
                    }
                    if(response.data.item.recurringCount !== -1){
                      this.formAddTask.reocuringCount = true;
                      this.formAddTask.reocuringCounter = response.data.item.recurringCount
                    }else{
                      this.formAddTask.reocuringCount = false
                    }
                    // this.formAddTask.progressNote,
                    if(response.data.item.allowExternalNotifications === 1){
                      this.formAddTask.allowExternalNotification = true
                    }else{
                      this.formAddTask.allowExternalNotification = false
                    }
                    // this.formAddTask.allowExternalNotification = response.data.item.allowExternalNotifications
                    this.formAddTask.clientsId = response.data.item.companyClientPersonIdList;
                    this.formAddTask.vendorsId = response.data.item.companyVendorPersonIdList;
                    this.formAddTask.typeTaskId = response.data.item.taskTypeId;
                    if(!response.data.item.leaderCompanyUserId) {
                      this.formAddTask.assignedToId = null
                    }else{
                      this.formAddTask.assignedToId = response.data.item.leaderCompanyUserId
                    }
                    this.formAddTask.taskTeamId = response.data.item.companyUserIdList;

                    // this.formAddTask.assignedTo

                    response.data.item.companyUserIdList.forEach(val => {
                     const companyUser = this.formAddTask.taskTeam.filter(companyUser => companyUser.id === val)[0];
                      this.formAddTask.assignedTo.push(companyUser)
                    });


                    this.formAddTask.startDay = response.data.item.reoccuringStartDate * 1000;
                    this.formAddTask.addTaskDocuments = !!response.data.item.addTaskDocument;

                    // DM
                    this.formAddTask.sopListId = response.data.item.sopId;
                    this.formAddTask.policyListId = response.data.item.policyId;
                    this.formAddTask.healthSafetyListId = response.data.item.healthSafetyId;
                    this.formAddTask.riskAssesmentListId = response.data.item.riskAssesmentId;
                    this.formAddTask.envirenmentalListId = response.data.item.envirenmentalId;

                    if (response.data.item.deadline) {
                      this.formAddTask.deadline = response.data.item.deadline
                      this.formAddTask.endedDate = response.data.item.deadlineDate
                    }

                    this.taskStatus = response.data.item.status

                    this.$nextTick(() => {
                      this.$refs.editor.setImagesState()
                    })

                    loader.hide()
                  }
                })
                .catch(error => {
                  this.notification("Notification", error.response.data.message, "warning")
                  loader.hide()
                  console.log('An error occurred:', error);
                });
            }
          })
          .catch(error => {
            loader.hide();
            console.log('An error occurred:', error);
          });
      },
      handleTaskFunctions(state, id) {
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/businessUnitTasks/directories?companyId=${this.$route.query.companyId}&businessUnitId=${this.$route.query.businessUnitId}&operation=${state}&taskTypeId=${id}`)
          .then(response => {
            console.log(response)
            this.formAddTask.functionTask = response.data.taskFunctionList
            loader.hide()
          })
          .catch(error => {
            this.notification("Notification", error.response.data.message, "warning")
            console.log('An error occurred:', error);
            loader.hide()
          })
      },
      changing(item){
        if(!item){
          // this.$refs['formAddTask'].resetFields();
          this.formAddTask.assignedToId = null
        }
        console.log(item)
      },
      cangedReocuringCount(val){
        this.$refs['formAddTask'].clearValidate('reocuringCounter')
      },
      ggg(value) {
        console.log(value)
      },
      modalCancel(ref) {
        this.$refs[ref].close();
      },
      handleSelectTeam(user){
        console.log('formAddTask.taskTeamId', this.formAddTask.taskTeamId);
        // const uniqueUser = this.formAddTask.assignedTo.filter(val => val.id === user.id)[0]
        // check if user in list
        this.formAddTask.assignedTo = [];
        this.formAddTask.taskTeamId.forEach(val => {
          const user = this.formAddTask.taskTeam.filter(bal => bal.id === val)[0];
          this.formAddTask.assignedTo.push(user)
        });

        // check selected leader
        if (this.formAddTask.assignedToId === user.id){
          this.formAddTask.assignedToId = null
        }
      },
      removeTag(tagId){
        this.formAddTask.assignedTo = [];
        this.formAddTask.taskTeamId.forEach(val => {
          const user = this.formAddTask.taskTeam.filter(bal => bal.id === val)[0];
          this.formAddTask.assignedTo.push(user)
        });

        // check selected leader
        if (this.formAddTask.assignedToId === tagId){
          this.formAddTask.assignedToId = null
        }

      },
      createMyList(list, personList, state) {
        console.log('list, personList, state', list, personList, state)
        const myList = []

        for (let i = 0; i < list.length; i++) {
          myList.push({ ...list[i], people: [] })
          if(state === 'vendors'){
            for (let j = 0; j < personList.length; j++) {
              if (list[i].companyVendorId === personList[j].companyVendorId) {
                myList[i].people.push(personList[j])
                // personList.splice(j, 1)
              }
            }
          }
          if(state === 'clients'){
            for (let j = 0; j < personList.length; j++) {
              if (list[i].companyClientId === personList[j].companyClientId) {
                myList[i].people.push(personList[j])
                // personList.splice(j, 1)
              }
            }
          }
        }
        console.log('myList11', myList)
        return myList
      },
      addTaskSubmit(form) {
        console.log('SELECTED ROW Type', this.selectedRow.type);
        if (this.selectedRow.type === "businessUnit"){
          this.businessUnitTaskId = null;
        }else{
          this.businessUnitTaskId = this.selectedRow.id;
        }
        this.$refs[form].validate((valid) => {
          if (valid) {
            let currentTime = Number(moment().format('X'))
            let startDay = this.formAddTask.startDay
            let daysCount = this.formAddTask.daysCount


            if (!this.formAddTask.reoccuringTask) {
              startDay = null
              daysCount = null
            } else {
              startDay = this.formAddTask.startDay / 1000
              if (this.changeDayOrHour == 1) {
                daysCount = this.formAddTask.daysCount * 24
              } else {
                daysCount = this.formAddTask.daysCount
              }

              const whenTaskStart = Number(moment(startDay, 'X').add(daysCount, 'hours').format('X'))

              if(this.formAddTask.reoccuringTask && currentTime > whenTaskStart){
                // this.notification("Notification", 'Start time can\'t be less than current', "warning")
                return this.$alert('<div>' + this.$t('notification_recurringStartDateCanOnlyBeBackDatedInlineWithTheFirstRecurringPeriod') + '</div>' + '<div>' + this.$t('notification_currentDate30thJun21RecurringDaysIs7RecurringStartDateCanOnlyBeBackDatedTo23rdJun21WhichisWithInOneRecurringPeriod') + '</div>', this.$t('notification_tfSupport'), {
                  confirmButtonText: 'Close',
                  dangerouslyUseHTMLString: true,
                  customClass: 'support-alert',
                  callback: action => {
                    console.log('action', action)
                  }
                });
              }
            }

            if (!this.formAddTask.addTaskDocuments) {
              this.formAddTask.sopListId = null
              this.formAddTask.policyListId = null
              this.formAddTask.healthSafetyListId = null
              this.formAddTask.riskAssesmentListId = null
              this.formAddTask.envirenmentalListId = null
            }

            let data = {
              name: this.formAddTask.taskName,
              description: this.formAddTask.aboutThisTask,
              priorityId: this.formAddTask.taskPriorityId,
              isReoccurring: this.formAddTask.reoccuringTask,
              repeatTaskInterval: daysCount || null,
              recuringCount: !this.formAddTask.reocuringCount ? -1 : this.formAddTask.reocuringCounter,
              parentBusinessUnitTaskId: this.selectedRow.id || null,
              leaderCompanyUserId: this.formAddTask.assignedToId || null,
              hasProgress: this.formAddTask.progressNote,
              allowExternalNotifications: this.formAddTask.allowExternalNotification,
              companyClientPersonIdList: this.formAddTask.clientsId,
              companyVendorPersonIdList: this.formAddTask.vendorsId,
              taskTypeId: this.formAddTask.typeTaskId,
              companyUserIdList: this.formAddTask.taskTeamId,
              reoccuringStartDate: startDay || null,
              taskFunctionId: this.formAddTask.functionTaskId,
              addTaskDocument: this.formAddTask.addTaskDocuments,

              // DM
              sopId: this.formAddTask.sopListId,
              policyId: this.formAddTask.policyListId,
              healthsafetyId: this.formAddTask.healthSafetyListId,
              riskAssesmentId: this.formAddTask.riskAssesmentListId,
              envirenmentalId: this.formAddTask.envirenmentalListId,

              deadline: this.formAddTask.deadline,
              endedDate: this.formAddTask.endedDate,
            }
            let loader = this.$loading.show();
            axios
              .post(`/api/v1/businessUnitTasks/create?companyId=${this.$route.query.companyId}&businessUnitId=${this.$route.query.businessUnitId}`, data)
              .then(response => {
                // Handle success.
                this.$emit('submit', this.$route.query.businessUnitId, 'created', response.data.businessUnitTaskId, this.formAddTask.reoccuringTask);
                // let id = this.activeBusinessUnitId
                // this.newCreatedBusinessUnitTask = response.data.businessUnitTaskId
                // this.setBusinessUnitRowData(id ,'created', false, this.formAddTask.reoccuringTask)
                this.$refs.addTask.close();
                this.notification("Success", "Add task", "success");
                loader.hide()
                if (this.$refs.editor.uploadedImagesArray.length) {
                  this.$store.dispatch('approveUploadedImages', {
                    fileUrlArr: this.$refs.editor.uploadedImagesArray,
                    entityId: response.data.businessUnitTaskId,
                    entityTypeId: 43 // bu task about entity
                  })
                }
              })
              .catch(error => {
                loader.hide()
                // Handle error.
              });
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      addTaskInsert(form) {
        if (this.selectedRow.type === "businessUnit"){
          this.businessUnitTaskId = null;
        }else{
          this.businessUnitTaskId = this.selectedRow.id;
        }
        this.$refs[form].validate((valid) => {
          if (valid) {
            let currentTime = Number(moment().format('X'))
            let startDay = this.formAddTask.startDay
            let daysCount = this.formAddTask.daysCount


            if (!this.formAddTask.reoccuringTask) {
              startDay = null
              daysCount = null
            } else {
              startDay = this.formAddTask.startDay / 1000
              if (this.changeDayOrHour == 1) {
                daysCount = this.formAddTask.daysCount * 24
              } else {
                daysCount = this.formAddTask.daysCount
              }

              const whenTaskStart = Number(moment(startDay, 'X').add(daysCount, 'hours').format('X'))

              if(this.formAddTask.reoccuringTask && currentTime > whenTaskStart){
                return this.$alert('<div>' + this.$t('notification_recurringStartDateCanOnlyBeBackDatedInlineWithTheFirstRecurringPeriod') + '</div>' + '<div>' + this.$t('notification_currentDate30thJun21RecurringDaysIs7RecurringStartDateCanOnlyBeBackDatedTo23rdJun21WhichisWithInOneRecurringPeriod') + '</div>', this.$t('notification_tfSupport'), {
                  confirmButtonText: 'Close',
                  dangerouslyUseHTMLString: true,
                  customClass: 'support-alert',
                  callback: action => {
                    console.log('action', action)
                  }
                });
              }
            }

            if (!this.formAddTask.addTaskDocuments) {
              this.formAddTask.sopListId = null
              this.formAddTask.policyListId = null
              this.formAddTask.healthSafetyListId = null
              this.formAddTask.riskAssesmentListId = null
              this.formAddTask.envirenmentalListId = null
            }

            let data = {
              name: this.formAddTask.taskName,
              description: this.formAddTask.aboutThisTask,
              priorityId: this.formAddTask.taskPriorityId,
              isReoccurring: this.formAddTask.reoccuringTask,
              repeatTaskInterval: daysCount || null,
              recuringCount: !this.formAddTask.reocuringCount ? -1 : this.formAddTask.reocuringCounter,
              parentBusinessUnitTaskId: this.selectedRow.parentBusinessUnitTaskId,
              leaderCompanyUserId: this.formAddTask.assignedToId || null,
              hasProgress: this.formAddTask.progressNote,
              allowExternalNotifications: this.formAddTask.allowExternalNotification,
              companyClientPersonIdList: this.formAddTask.clientsId,
              companyVendorPersonIdList: this.formAddTask.vendorsId,
              taskTypeId: this.formAddTask.typeTaskId,
              companyUserIdList: this.formAddTask.taskTeamId,
              reoccuringStartDate: startDay || null,
              taskFunctionId: this.formAddTask.functionTaskId,
              addTaskDocument: this.formAddTask.addTaskDocuments,

              // DM
              sopId: this.formAddTask.sopListId,
              policyId: this.formAddTask.policyListId,
              healthsafetyId: this.formAddTask.healthSafetyListId,
              riskAssesmentId: this.formAddTask.riskAssesmentListId,
              envirenmentalId: this.formAddTask.envirenmentalListId,

              deadline: this.formAddTask.deadline,
              endedDate: this.formAddTask.endedDate,
            };
            let loader = this.$loading.show();
            axios
              .post(`/api/v1/businessUnitTasks/insert?companyId=${this.$route.query.companyId}&businessUnitId=${this.$route.query.businessUnitId}&orderIndex=${this.selectedRow.orderIndex}`, data)
              .then(response => {
                // Handle success.
                this.$emit('submit', this.$route.query.businessUnitId, 'created', response.data.businessUnitTaskId, this.formAddTask.reoccuringTask);
                // let id = this.activeBusinessUnitId
                // this.newCreatedBusinessUnitTask = response.data.businessUnitTaskId
                // this.setBusinessUnitRowData(id ,'created', false, this.formAddTask.reoccuringTask)
                this.$refs.addTask.close();
                this.notification("Success", "Add task", "success");
                loader.hide()
                if (this.$refs.editor.uploadedImagesArray.length) {
                  this.$store.dispatch('approveUploadedImages', {
                    fileUrlArr: this.$refs.editor.uploadedImagesArray,
                    entityId: response.data.businessUnitTaskId,
                    entityTypeId: 43 // bu task about entity
                  })
                }
              })
              .catch(error => {
                loader.hide()
                // Handle error.
              });
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      editTaskSubmit(form) {
        console.log('SELECTED ROW Type', this.selectedRow.type);
        this.$refs[form].validate((valid) => {
          if (valid) {
            let currentTime = Number(moment().format('X'))
            let startDay = this.formAddTask.startDay
            let daysCount = this.formAddTask.daysCount


            if (!this.formAddTask.reoccuringTask) {
              startDay = null
              daysCount = null
            } else {
              startDay = this.formAddTask.startDay / 1000
              if (this.changeDayOrHour == 1) {
                daysCount = this.formAddTask.daysCount * 24
              } else {
                daysCount = this.formAddTask.daysCount
              }

              const whenTaskStart = Number(moment(startDay, 'X').add(daysCount, 'hours').format('X'))

              if(this.formAddTask.reoccuringTask && currentTime > whenTaskStart){
                return this.$alert('<div>' + this.$t('notification_recurringStartDateCanOnlyBeBackDatedInlineWithTheFirstRecurringPeriod') + '</div>' + '<div>' + this.$t('notification_currentDate30thJun21RecurringDaysIs7RecurringStartDateCanOnlyBeBackDatedTo23rdJun21WhichisWithInOneRecurringPeriod') + '</div>', this.$t('notification_tfSupport'), {
                  confirmButtonText: 'Close',
                  dangerouslyUseHTMLString: true,
                  customClass: 'support-alert',
                  callback: action => {
                    console.log('action', action)
                  }
                });
              }
            }

            if (!this.formAddTask.addTaskDocuments) {
              this.formAddTask.sopListId = null
              this.formAddTask.policyListId = null
              this.formAddTask.healthSafetyListId = null
              this.formAddTask.riskAssesmentListId = null
              this.formAddTask.envirenmentalListId = null
            }

            const data = {
              name: this.formAddTask.taskName,
              description: this.formAddTask.aboutThisTask,
              priorityId: this.formAddTask.taskPriorityId,
              // isReoccurring: this.formAddTask.reoccuringTask,
              repeatTaskInterval: daysCount || null,
              recuringCount: !this.formAddTask.reocuringCount ? -1 : this.formAddTask.reocuringCounter,
              // parentBusinessUnitTaskId: this.businessUnitTaskId,
              leaderCompanyUserId: this.formAddTask.assignedToId || null,
              hasProgress: this.formAddTask.progressNote,
              allowExternalNotifications: this.formAddTask.allowExternalNotification,
              companyClientPersonIdList: this.formAddTask.clientsId,
              companyVendorPersonIdList: this.formAddTask.vendorsId,
              // taskTypeId: this.formAddTask.typeTaskId,
              companyUserIdList: this.formAddTask.taskTeamId,
              reoccuringStartDate: startDay || null,
              addTaskDocument: this.formAddTask.addTaskDocuments,

              // DM
              sopId: this.formAddTask.sopListId,
              policyId: this.formAddTask.policyListId,
              healthsafetyId: this.formAddTask.healthSafetyListId,
              riskAssesmentId: this.formAddTask.riskAssesmentListId,
              envirenmentalId: this.formAddTask.envirenmentalListId,

              deadline: this.formAddTask.deadline,
              endedDate: this.formAddTask.endedDate,
            }
            let loader = this.$loading.show();
            axios
              .post(`/api/v1/businessUnitTasks/update?companyId=${this.$route.query.companyId}&businessUnitId=${this.$route.query.businessUnitId}&businessUnitTaskId=${this.selectedRow.id}`, data)
              .then(response => {
                // Handle success.
                this.$emit('submit', this.$route.query.businessUnitId, 'created', this.selectedRow.id, this.formAddTask.reoccuringTask);
                this.$refs.addTask.close();
                this.notification("Success", "Edit task", "success");
                loader.hide()
                if (this.$refs.editor.uploadedImagesArray.length) {
                  this.$store.dispatch('approveUploadedImages', {
                    fileUrlArr: this.$refs.editor.uploadedImagesArray,
                    entityId: this.selectedRow.id,
                    entityTypeId: 43 // bu task about entity
                  })
                }

                if (this.$refs.editor.removedImages.length) {
                  this.$store.dispatch('deleteRemovedImages', this.$refs.editor.removedImages)
                }
              })
              .catch(error => {
                loader.hide()
              });
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      closeTaskModal(){
        this.formAddTask.typeTask = '';
        this.formAddTask.typeTaskId = '';
        this.formAddTask.functionTaskId = '';
        this.formAddTask.functionTask = [];
        this.formAddTask.aboutThisTask = '';
        this.formAddTask.taskTeam = [];
        this.formAddTask.taskTeamId = [];
        this.formAddTask.daysCount = 1;
        this.formAddTask.taskPriority = [];
        this.formAddTask.progressNote = false;
        this.formAddTask.clients = '';
        this.formAddTask.clientsId = [];
        this.formAddTask.vendors = '';
        this.formAddTask.vendorsId = [];
        this.formAddTask.allowExternalNotification = false;
        this.formAddTask.startDay = '';
        this.formAddTask.reocuringCount = false;
        this.formAddTask.reocuringCounter = 1;
        this.editDisabled = false;
        this.isEditActivated = false;
        this.formAddTask.assignedTo = [];
        this.formAddTask.assignedToId = null;
        this.formAddTask.sopList = [];
        this.formAddTask.sopListId = null;
        this.formAddTask.policyList = [];
        this.formAddTask.policyListId = null;
        this.formAddTask.healthSafetyList = [];
        this.formAddTask.healthSafetyListId = null;
        this.formAddTask.riskAssesmentList = [];
        this.formAddTask.riskAssesmentListId = null;
        this.formAddTask.envirenmentalList = [];
        this.formAddTask.envirenmentalListId = null;
        this.formAddTask.addTaskDocuments = false;

        this.formAddTask.deadline = false;
        this.formAddTask.endedDate = null;

        this.$refs['formAddTask'].resetFields()
        this.taskStatus = 1
      },
      handleImageAdded: function(file, Editor, cursorLocation, resetUploader) {
        console.log("FILE",file);
        // this.form.imageUrl = URL.createObjectURL(file.raw);
        // console.log('---', this.form.imageUrl);
        var formData = new FormData();
        formData.append('file', file);

        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/files/create?companyId=${this.$route.query.companyId}`, formData, {'Content-Type': 'multipart/form-data'})
          .then(response => {
            let url = response.data.fileUrl // Get url from response
            Editor.insertEmbed(cursorLocation, 'image', url);
            resetUploader();
            loader.hide()
          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          })
      },
      notification(title, message, type) {
        this.$notify({
          title: title,
          message: message,
          type: type
        });
      }
    },
    watch:{
      reoccuringTask(val){
        if (val){
          this.formAddTask.progressNote = true
          this.addProgDisabled = true
        }else{
          this.formAddTask.progressNote = false
          this.addProgDisabled = false
        }
      },
      'formAddTask.deadline'(val) {
        if (!val) {
          this.formAddTask.endedDate = null
          this.formAddTask.progressNote = false
          this.addProgDisabled = false
        } else {
          this.formAddTask.progressNote = true
          this.addProgDisabled = true
        }
      },
    }
  }
</script>

<style scoped lang="less">
    .flex-end{
        display:flex;
        justify-content: flex-end;
    }
    .el-select {
        width:100%;
    }
    .el-date-editor.el-input {
        width:100% !important;
    }
    .aboutButton{
      display: flex;
      justify-content: center;
      margin-bottom: 18px;
    }
    .input-recuring-counter{
        width:50px;
    }
</style>

<style lang="less">
.el-message-box__wrapper {
  z-index: 9999 !important;
}
</style>
